import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { WindowContents } from '../../shared/enums/windowContents';
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';
import { EmployeeService } from '../../shared/services/employee.service';
import { DispatchDropLocation } from '../../shared/models/DispatchDropLocation';

import { Observable, of, Subject, Subscription } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { delay, mergeMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'cp-tech-panel',
    templateUrl: './tech-panel.component.html',
    styleUrls: ['./tech-panel.component.scss']
})
export class TechPanelComponent implements OnInit {

    subscriptions: Subscription[] = [];

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private svc_data_emp: EmployeeService) {
        this.subscriptions.push(svc_data.assignTech$.subscribe(
            dispatch => {
                this.openWindow(dispatch);
            }));
        this.subscriptions.push(svc_data.hoverTechPanel$.subscribe(
            tech => {
                if (tech) {

                    this.openDetail(tech);
                }
            }));
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                this.initData();
            }));
    }

    private _mouseEnterStream: EventEmitter<any> = new EventEmitter();
    private _mouseLeaveStream: EventEmitter<any> = new EventEmitter();

    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: any = [];
    searchParam: DispatchBoardSearch;
    filterSettings: DropDownFilterSettings;

    panelType: DispatchBoardPanels = DispatchBoardPanels.tech;
    boardPersonsData: any;
    @Input() selectedView: string;
    @Input() viewName: any;
    @Output() openRequest = new EventEmitter<object>();
    @Output() openDetailRequest = new EventEmitter<object>();
    popupLock: boolean = false;
    loadingIndicator: boolean = true;
    quickFilter: string;
    quickFilterError: boolean = false;

    mouseDown: boolean = false;

    public contentTypes = WindowContents;

    ngOnChanges() {
        this.initData();
    }
    ngOnInit() {
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        this.filterSettings = this.svc_data.filterSettings;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    initData() {
        if (this.selectedView) {
            //this.loadingIndicator = true;
            //this.boardPersonsData = null;
            //this.data = null;
            this.svc_data.GetDispatchBoardViewPersons(this.selectedView).subscribe(data => {
                this.boardPersonsData = data;

                this.svc_data.boardPersonsData = this.boardPersonsData;

                if (data.error) {
                    alert('got an error back!');
                }

                this.searchParam.boardPersons = [];
                for (var i = 0; i < this.boardPersonsData.length; i++) {
                    this.searchParam.boardPersons.push(this.boardPersonsData[i].personId);
                }
                //this.svc_data_emp.getTechsByFilter(this.searchParam).subscribe(data => {
                //    for (var i = 0; i < data.length; i++) {
                //        data[i].fullName = data[i].firstName + ' ' + data[i].lastName;
                //    }
                //    this.data = data;
                //    this.svc_data.techList = data;
                //    this.loadingIndicator = false;

                //    if (data.error) {
                //        alert('got an error back!');
                //    }
                //
                //});
            });
            this.svc_data_emp.getTechsByFilter(this.svc_data.searchParams).subscribe(data => {
                for (var i = 0; i < data.length; i++) {
                    data[i].fullName = data[i].firstName + ' ' + data[i].lastName;
                }
                this.data = data;
                this.svc_data.techList = data;
                this.loadingIndicator = false;

                if (data.error) {
                    alert('got an error back!');
                }
            });
        }
    }

    openWindow(dispatch) {
        let passedData = { data: this.data, assignDispatch: dispatch };
        let windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };
        this.openRequest.emit(windowData);
    }

    openDetail(details) {

        this.openDetailRequest.emit({ lock: !this.popupLock, detail: details });
    }

    setPopupLock(e) {
        this.popupLock = e;
    }

    filterChange(e) {
        //is value in list?
        if (e.length > 0 && this.data.find(obj => obj.fullName == e)) {
            this.quickFilterError = false;
        } else if (e.length > 0) {
            this.quickFilterError = true;
        } else {
            this.quickFilterError = false;
        }
        this.quickFilter = e;
    }

    mouseUp(tech: DispatchDropLocation) {
        if (!this.mouseDown) {
            this.svc_data.dispatchDropped(tech);
        }
        this.mouseDown = false;
    }

    mouseOver(tech: DispatchDropLocation) {
        this.svc_data.mouseHovering(tech);
    }

    subs_mouseEnter: Subscription;
    mouseEnter(e, tech) {
        CommonFunctions.unsubscribe(this.subs_mouseEnter);
        this.subs_mouseEnter = this._mouseEnterStream.pipe(mergeMap((ev) => {
            return of(ev)
                .pipe(delay(850))
                .pipe(takeUntil(this._mouseLeaveStream));
        })).subscribe(
            (ev) => {

                //this.openDetail(tech);
                this.svc_data.hoveringTechPanel(tech);
            }
        );
    }
    onMouseEnter(e) {

        this._mouseEnterStream.emit(e);
    }

    onMouseLeave(e) {

        this._mouseLeaveStream.emit(e);
    }
}
